import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Accordion } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import Sidebar from '../../../../Sidebar/Sidebar';
import AppLink from '../../../../../routing/helpers/AppLink';
import Translator from '../../../../components/helpers/Translator';
import FilterSidebarBlock from './FilterSidebarBlock';
import ReportSidebarBlock from './ReportSidebarBlock';

export default function InecoRiskManagerSidebar({ activeRoute }) {
  const { moduleBridgeHex } = useParams();
  const auth = useSelector((state) => state.auth);
  const permissionLevel = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.userBridge?.permissions?.level
  );

  return (
    <Sidebar>
      <img
        src={auth.user?.client?.logoUrl}
        className="img-fluid"
        alt={auth.user?.client?.name}
        title={auth.user?.client?.name}
      />
      <Accordion>
        <ul>
          {activeRoute === 'user_module_inecoRiskManager_risk_list' && (
            <>
              <FilterSidebarBlock />
              <ReportSidebarBlock />
            </>
          )}
          <li className="divider" />
          <li
            className={`${
              activeRoute === 'user_module_inecoRiskManager_risk_list'
                ? 'active'
                : ''
            }`}
          >
            <AppLink
              path="user_module_inecoRiskManager_risk_list"
              params={{
                moduleBridgeHex,
                page: 1,
                filtersHex: 0,
              }}
              className="p-0"
            >
              <span className="sidebar-element" title="Riesgos y oportunidades">
                <span className="sb-title">Riesgos y oportunidades</span>
              </span>
            </AppLink>
          </li>
          {permissionLevel === 0 && (
            <li
              className={`${
                activeRoute === 'user_module_inecoRiskManager_risk_add'
                  ? 'active'
                  : ''
              }`}
            >
              <AppLink
                path="user_module_inecoRiskManager_risk_add"
                params={{
                  moduleBridgeHex,
                }}
                className="p-0"
              >
                <span
                  className="sidebar-element"
                  title="Nuevo riesgo u oportunidad"
                >
                  <span className="sb-title">Nuevo riesgo u oportunidad</span>
                </span>
              </AppLink>
            </li>
          )}
          <li
            className={`${
              activeRoute === 'user_module_inecoRiskManager_milestone_list'
                ? 'active'
                : ''
            }`}
          >
            <AppLink
              path="user_module_inecoRiskManager_milestone_list"
              params={{
                moduleBridgeHex,
              }}
              className="p-0"
            >
              <span
                className="sidebar-element"
                title="Histórico de riesgos y oportunidades organizacionales"
              >
                <span className="sb-title">Histórico</span>
              </span>
            </AppLink>
          </li>
        </ul>
      </Accordion>
    </Sidebar>
  );
}
